import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

export default function ComponentRouteWrapper({ Component, onEnter, onLeave, routeChangeEventTriggerAction, location, match, ...rest }) {
  useEffect(() => {
    onEnter(match);
    routeChangeEventTriggerAction(location.pathname, match.params);
    return () => {
      onLeave(match);
    };
  }, [location.pathname, match.url]);

  return <Component location={location} {...rest} />;
}

ComponentRouteWrapper.propTypes = {
  Component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  routeChangeEventTriggerAction: PropTypes.func,
  location: PropTypes.object,
  match: PropTypes.object,
};

ComponentRouteWrapper.defaultProps = {
  onEnter: noop,
  onLeave: noop,
};
